<template>
  <OrderComponent :id="id" />
</template>

<script>
// @ is an alias to /src
import OrderComponent from "@/components/Account/Pages/Orders/Order/Order.vue";

export default {
  props: ["id"],
  name: "Order",
  components: {
    OrderComponent
  }
};
</script>
